<template>
  <div>
    <div class="row">
      <telefones @statusChange="handleStatusChange" ref="telefones" v-bind:telefones_data="contatos_data.telefones" v-bind:pf_id="pf_id" />
      <emails v-bind:emails_data="contatos_data.emails" ref="emails" v-bind:pf_id="pf_id" />
      <enderecos @statusChange="handleStatusChange" ref="enderecos" v-bind:endereco_data="contatos_data.enderecos" v-bind:pf_id="pf_id" />
      <redes-sociais @statusChange="handleStatusChange" ref="redes_sociais" v-bind:pf_id="pf_id" />
    </div>

    <div class="step-actions">
      <button type="button" class="waves-effect waves-dark btn-flat previous-step">Anterior</button>
      <button v-bind:disabled="step_completed === false" type="button" class="waves-effect waves-dark btn next-step">Próximo</button>
    </div>
  </div>
</template>
<script>
import Telefones from '@/components/steps/contatos/Telefones.vue'
import Enderecos from '@/components/steps/contatos/Enderecos.vue'
import Emails from '@/components/steps/contatos/Emails.vue'
import RedesSociais from '@/components/steps/contatos/RedesSociais.vue'

export default {
  name: 'Contatos',
  components: {
    telefones: Telefones,
    enderecos: Enderecos,
    emails: Emails,
    'redes-sociais': RedesSociais
  },
  props: {
    contatos_data: Object
  },
  data (){
    return {
      meta: this.$store.state.meta.data,
      pf_id: this.$store.state.user.pfId,
      step_completed: false,
      error: null,
      selectedMunicipio: localStorage.selectedMunicipio
    }
  },
  methods: {
    async submitPerfil(){
      this.$root.$emit('loadingHeader')
      this.loading_step = true
      let pefil_updated = Object.assign({}, this.perfil)
      localStorage[`contatos_${this.pf_id}`] = JSON.stringify(this.perfil)

      setTimeout(() => {
        this.$root.$emit('stopLoadingHeader')
        this.loading_step = false
        this.$emit('moveNextStep', {step: 0, completed: this.step_completed})
      }, 1000)
    },
    get_filiacao(tipo){
      if(this.perfil_data.filiacao){
        let parent = this.perfil_data.filiacao.filter(f => f['pf_filiacao_tipo'] === tipo)
        if(parent.length > 0){
          return parent[0]['pf_filiacao_nome']
        } else {
          return 'N/I'
        }
      }
    },
    searchCEP(){
      let end_cep = this.end['end_cep'].replace(/\D/g, '')
      if(end_cep.length === 8){
        this.$root.$emit('loadingHeader')
        this.locked = true
        this.getCepInfo(end_cep)
      } else {
        this.cep_info = {}
        this.setCepInfo(this.cep_info)
      }
    },
    submitStep() {
      if(this.changed === true){
        this.submitPerfil()
      } else {
        this.$emit('moveNextStep', {step: 0, completed: this.step_completed})
      }
    },
    verificaStatusPasso(){
      const result = []
      this.meta.censo_domain[this.selectedMunicipio].formulario_documentos_obrigatorios.contatos.map(docs => {
        if(this.$refs[docs][docs].length > 0) {
          result.push(true)
        } else {
          result.push(false)
        }
      })
      if(result.includes(false)) {
        return false
      } else {
        return true
      }
      // return this.$refs.telefones.telefones.length > 0 && this.$refs.enderecos.enderecos.length > 0
    },
    handleStatusChange(){
      this.step_completed = this.verificaStatusPasso()
    },
    initStep(){
      setTimeout(() => {
        M.updateTextFields()
        M.FormSelect.init(document.querySelectorAll('select'))
        M.Tooltip.init(document.querySelectorAll('.tooltipped'))
        this.changed = false
      }, 200)
    },
    loadFields() {
      setTimeout(() => {
        M.updateTextFields()
        M.FormSelect.init(document.querySelectorAll('select'))
        M.Tooltip.init(document.querySelectorAll('.tooltipped'))
      }, 200)
    },
    addNewEmail() {
      this.form_email = !this.form_email
      if (this.form_email === true) {
        this.loadFields()
      }
    },
    addNewAddress() {
      this.form_address = !this.form_address
      if (this.form_address === true) {
        this.loadFields()
      }
    },
  },
  mounted(){
    this.initStep()
    this.step_completed = this.verificaStatusPasso()
  }
}
</script>


// WEBPACK FOOTER //
// src/components/steps/Contatos.vue